import React, { Component } from "react";
import {
  Layout,
  Spin,
  Input,
  Row,
  Col,
  message,
} from "antd";
import { UserOutlined } from "@ant-design/icons";
import logoGrande from "../../assets/Biwo logo grande.png";
import bienvenidaLogin from "../../assets/Bienvenida-Banner-Biwo.png";
import { NavLink } from "react-router-dom";
import { ButtonItem, ErrorItem, Form, FormItem } from "../../Components/Items";
import axios from "axios";

const { Content } = Layout;

const urlContent = process.env.NODE_ENV === "development" ? `http://192.168.100.83:3000` : "https://biwo.online";

class RecuperarContrasena extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    imagenUrl: `${urlContent}/public/login/Bienvenida-Banner-Biwo.png`,
    textoGlass: "",
    mostrarCard: true,
  };

  componentDidMount() {
    const defaultImage = `${urlContent}/public/login/Bienvenida-Banner-Biwo.png`;

    axios.post("apariencia/obtenerConfiguracionLoginPublico", {})
      .then((res) => {
        const config = res.data;
        this.setState({
          imagenUrl: defaultImage + "?t=" + Date.now(),
          textoGlass: config.textoGlass || "",
          mostrarCard: config.mostrarGlass !== false,
        });
      })
      .catch(() => {
        this.setState({
          imagenUrl: defaultImage + "?t=" + Date.now(),
          mostrarCard: true,
        });
      });
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post("/recuperarContrasena", values, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Cheque su correo para cambiar la contraseña");
          this.formRef.current.resetFields();
        } else if (res.data.success === 1) {
          message.warning(res.data.message);
        } else {
          message.error("Hubo un error y no pudimos mandarle el correo, porfavor comuniquese con nosotros");
        }
      });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    return (
      <Layout id="login-layout">
        <Content>
          <Spin size="large" spinning={this.state.loading}>
            <Row id="login-row">


              <Col xs={0} sm={0} lg={13} xl={13} id="login-col-imagen">
                <div id="login-imagen-card">
                  <img
                    src={this.state.imagenUrl}
                    alt="Biwo"
                    id="login-imagen"
                    onError={(e) => { e.target.src = bienvenidaLogin; }}
                  />
                  {this.state.mostrarCard && (
                    <div className="login-glass-card">
                      {this.state.textoGlass ? (
                        <p
                          className="login-glass-text"
                          dangerouslySetInnerHTML={{ __html: this.state.textoGlass }}
                        />
                      ) : (
                        <p className="login-glass-text">
                          Transforma cada desafío en una{" "}oportunidad con nuestro <span className="login-glass-highlight">ERP</span>: organiza, optimiza y avanza hacia el éxito con confianza
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </Col>


              <Col xs={24} sm={24} lg={11} xl={11} id="login-col-form">
                <div className="login-form-container" style={{ paddingTop: '6rem' }}>

                  <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                    <img src={logoGrande} alt="Biwo" style={{ maxWidth: '220px', width: '100%' }} />
                  </div>

                  <p style={{ color: '#64748b', marginBottom: '1.5rem', fontSize: '14px' }}>
                    Ingresa tu correo o usuario para restablecer tu contraseña.
                  </p>

                  <Form
                    defaultBehavior
                    name="recuperarContrasena"
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                    ref={this.formRef}
                  >
                    <FormItem name="usuario" pattern required max={200} min={5}>
                      <Input
                        placeholder="Correo o usuario"
                        prefix={<UserOutlined style={{ color: "#94a3b8" }} />}
                        size="large"
                        maxLength={200}
                      />
                    </FormItem>

                    <FormItem style={{ marginTop: "0", marginBottom: "4px" }}>
                      <ButtonItem
                        htmlType="submit"
                        type="primary"
                        cyan
                        style={{
                          height: "44px",
                          width: "100%",
                          fontSize: "18px",
                          fontWeight: "600",
                        }}
                      >
                        Recuperar Contraseña
                      </ButtonItem>
                    </FormItem>

                    <div className="login-forgot-link" style={{ textAlign: 'center', marginTop: '20px' }}>
                      <NavLink to="/login">← Regresar al Login</NavLink>
                    </div>
                  </Form>

                  <hr className="login-divider" />

                  <p className="login-footer">Biwo ©2026</p>
                </div>
              </Col>

            </Row>
          </Spin>
        </Content>
      </Layout>
    );
  }
}

export default RecuperarContrasena;
